import { CSSProperties } from "react";
import {
  NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  NOTE_PREVIEW_INLINE_LABEL_SEPARATOR,
  NOTE_PREVIEW_LABELS,
  NOTE_PREVIEW_MUTED_COLOR,
  NOTE_PREVIEW_NESTED_INDENT_PX,
  NOTE_PREVIEW_TEXT_COLOR,
} from "../note-preview-constant";
import { NotePreviewHierarchyGroup } from "../note-preview-types";

export interface ReportHierarchyGroupProps {
  group: NotePreviewHierarchyGroup;
  style?: CSSProperties;
}

const textStyle: CSSProperties = {
  fontSize: NOTE_PREVIEW_BODY_FONT_SIZE_PX,
  lineHeight: 1.5,
  color: NOTE_PREVIEW_TEXT_COLOR,
  breakInside: "avoid",
};

/** Sub-section heading, one bullet per ticked option, labelled details indented beneath, then "Notes: …". */
const ReportHierarchyGroup = ({ group, style }: ReportHierarchyGroupProps) => (
  <div style={{ marginBottom: 8, ...style }}>
    <div style={{ ...textStyle, fontWeight: 600, breakAfter: "avoid" }}>
      {group.title}
    </div>
    {group.selections.length > 0 && (
      <ul style={{ margin: "2px 0 0", paddingLeft: 18 }}>
        {group.selections.map((selection, index) => (
          <li key={index} style={textStyle}>
            {selection}
          </li>
        ))}
      </ul>
    )}
    {group.details.map((detail) => (
      <p
        key={detail.label}
        style={{
          ...textStyle,
          margin: `2px 0 0 ${NOTE_PREVIEW_NESTED_INDENT_PX + 18}px`,
        }}
      >
        <span style={{ color: NOTE_PREVIEW_MUTED_COLOR }}>
          {detail.label}
          {NOTE_PREVIEW_INLINE_LABEL_SEPARATOR}
        </span>
        {detail.value}
      </p>
    ))}
    {group.notes.map((note, index) => (
      <p
        key={index}
        style={{
          ...textStyle,
          margin: `4px 0 0 ${NOTE_PREVIEW_NESTED_INDENT_PX}px`,
        }}
      >
        <span style={{ fontWeight: 600 }}>
          {NOTE_PREVIEW_LABELS.notes}
          {NOTE_PREVIEW_INLINE_LABEL_SEPARATOR}
        </span>
        {note}
      </p>
    ))}
  </div>
);

export default ReportHierarchyGroup;
